module.exports = __webpack_public_path__ + "static/media/map-layer-default--new~bfuBHjfI.caa563ca.svg";